// extracted by mini-css-extract-plugin
export default {"content":"style_content__bsUOB","itemName":"style_itemName__LYD3k"};